  <template>
  <el-container class="configuration">
    <el-header height="60px">
      <span style="margin-right: 10px;">站点：</span>
      <el-select v-model="selSite" @change="siteChange" class="tt-input-extra dark-inner-extra">
        <el-option v-for="(site, i) in siteList" :key="i" :value="i" :label="site.buildName"></el-option>
      </el-select>
      <span style="margin-left: 40px;margin-right: 10px;">系统图：</span>
      <el-select v-if="drawList.length > 0" v-model="selDraw" @change="drawChange" class="tt-input-extra dark-inner-extra">
        <el-option v-for="(draw, i) in drawList" :key="i" :value="draw.id" :label="draw.drawName"></el-option>
      </el-select>
      <el-row style="width: 220px;text-align: left;" v-else>
        暂无数据
      </el-row>
    </el-header>
    <el-main id="mainContent">
      <draw-display v-if="svgUrl !== ''" :svgUrl="svgUrl" :idList="idList" :drawId="selDraw"></draw-display>
      <el-row v-else style="width: 100%;height: 100%;color: #ffffff;font-size: 24px;display: flex;align-items: center; justify-content: center;">
        暂无数据
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import DrawDisplay from './DrawDisplay'
export default {
  name: "Configuration",
  components: {DrawDisplay},
  data() {
    return {
      selSite: 0,
      siteList: [],
      selDraw: '',
      drawList: [],
      svgUrl: '',
      idList: ''
    }
  },
  created() {
    this.$api.energyDisplay.getSvgList().then(res => {
      this.siteList = res.data;
      this.selSite = 0;
      this.drawList = res.data[0].svgList;
      if (res.data[0].svgList.length > 0) {
        this.selDraw = res.data[0].svgList[0].id
        this.idList = this.drawList[0].sensorId
        this.svgUrl = 'https://ecms.yukui-tech.com/energyDisplay/getSvgFile?id=' + res.data[0].svgList[0].id
      }
    })
  },
  methods: {
    siteChange(val) {
      this.drawList = this.siteList[val].svgList
      if (this.drawList.length > 0) {
        this.selDraw = this.drawList[0].id
        this.idList = this.drawList[0].sensorId
        this.svgUrl = 'https://ecms.yukui-tech.com/energyDisplay/getSvgFile?id=' + this.drawList[0].id
      } else {
        this.selDraw = ''
        this.idList = ''
        this.svgUrl = ''
      }
    },
    drawChange(val) {
      if (val !== '') {
        this.svgUrl = 'https://ecms.yukui-tech.com/energyDisplay/getSvgFile?id=' + val
      }
    }
  }
}
</script>

<style scoped>
  .configuration {
    width: 100%;
    height: 100%;
  }
  .el-header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
    color: rgb(242, 242, 242);
    font-size: 14px;
  }
  .el-main {
    padding: 0;
    overflow: hidden;
    background-color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyMonitor/Configuration.vue